import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Payments {

}

interface PaymentsState {
    data: Payments[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_FOOD_ORDER_PORT;
const URL = import.meta.env.VITE_API_FOOD_ORDER_URL;

export const getByIdCustomerOrderRefund = createAsyncThunk<
    any,
    { order_id: number },
    { rejectValue: string }
>(
    "payments/getByIdCustomerOrderRefund",
    async ({ order_id }, { rejectWithValue }) => {
        try {
            const config = { params: { order_id } };

            const response = await apiService.get<Payments>(
                `get_by_id_customer_order_refund`,
                PORT,
                URL,
                config
            );
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch food menu ingredients');
        }
    }
);
export const PaymentsSlice = createSlice({
    name: 'payments',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as PaymentsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getByIdCustomerOrderRefund.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdCustomerOrderRefund.fulfilled, (state, action: PayloadAction<Payments[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getByIdCustomerOrderRefund.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

    },
});

export default PaymentsSlice.reducer;
